import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { Container, Row, Col } from 'reactstrap'
import { acceptAllExceptSingleSpecialCharacter, checkSpacesInString, checkWhiteSpaces, hashValidation, maxLength80, required } from '../../../helper/validation'
import { renderText, validateForm } from '../../layout/FormInputs'
import { getMachineSelectList } from '../actions/MachineMaster'
import { getProcessCode, createProcess, updateProcess, getProcessData, } from '../actions/Process'
import Toaster from '../../common/Toaster'
import { MESSAGES } from '../../../config/message'
import { loggedInUserId } from '../../../helper/auth'
import Drawer from '@material-ui/core/Drawer'
import DayTime from '../../common/DayTimeWrapper'
import LoaderCustom from '../../common/LoaderCustom'
import { debounce } from 'lodash'
import PopupMsgWrapper from '../../common/PopupMsgWrapper'
import { Steps } from './TourMessages'
import { withTranslation } from 'react-i18next'
import TourWrapper from '../../common/Tour/TourWrapper'
import Button from '../../layout/Button';
const selector = formValueSelector('AddProcessDrawer');

class AddProcessDrawer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedPlants: [],
      selectedMachine: [],
      ProcessId: '',
      effectiveDate: '',
      isLoader: false,
      setDisable: this.props.initialConfiguration?.IsAutoGeneratedProcessCode ? true : false,
      DataToChange: [],
      processName: "",
      showPopup: false,
    }
  }

  /**
   * @method componentDidMount
   * @description called after render the component
   */
  componentDidMount() {
    if (!(this.props.isEditFlag || this.props.isViewFlag)) {
      this.props.getMachineSelectList(() => { })
    }
    this.getData()
  }

  /**
   * @method getData
   * @description Used to get process data
   */
  getData = () => {
    const { isEditFlag, ID } = this.props

    if (isEditFlag) {
      this.setState({ isLoader: true })
      this.props.getProcessData(ID, res => {
        let Data = res.data.Data
        this.setState({ DataToChange: Data })
        this.setState({
          ProcessId: Data.ProcessId,
          effectiveDate: DayTime(Data.EffectiveDate).isValid() ? DayTime(Data.EffectiveDate) : ''
        })
        this.setState({ isLoader: false })
      })
    } else {
      this.props.getProcessData('', (res) => { })
    }
  }

  toggleDrawer = (event, formData, type) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }
    this.props.closeDrawer('', formData, type)
  }

  checkProcessCode = (e) => {
    const value = e.target.value
    let obj = {
      processName: value,
      processCode: ""
    }
    this.setState({ processName: value, setDisable: false })
    if (e?.target?.value) {
      this.props.getProcessCode(obj, (res) => {
        if (res && res.data && res.data.Result) {
          let Data = res.data.DynamicData
          this.props.change('ProcessCode', Data.ProcessCode)
        }
      })
    }
  }

  checkProcessCodeUnique = (e) => {
    const value = e.target.value
    let obj = {
      processName: this.state.processName,
      processCode: value
    }
    this.props.getProcessCode(obj, (res) => {

      let Data = res.data.DynamicData
      if (Data?.IsExist) {

        if (this.state.processName) {
          this.props.change('ProcessCode', Data.ProcessCode)
        } else {
          Toaster.warning(res.data.Message);
          this.props.change('ProcessCode', "")
        }
      }
    })

  }

  handleProcessName = (e) => {
    this.setState({ setDisable: this.props.initialConfiguration?.IsAutoGeneratedProcessCode ? true : false })
  }

  handleProcessCode = (e) => {
    this.setState({ setDisable: false })
  }

  /**
   * @method handlePlants
   * @description Used handle Plants
   */
  handlePlants = (e) => {
    this.setState({ selectedPlants: e })
  }

  /**
   * @method handleMachine
   * @description Used handle Machine
   */
  handleMachine = (e) => {
    this.setState({ selectedMachine: e })
  }

  /**
    * @method handleChange
    * @description Handle Effective Date
    */
  handleEffectiveDateChange = (date) => {
    this.setState({
      effectiveDate: date,
    })
  }

  /**
   * @method renderListing
   * @description Used show listing of unit of measurement
   */
  renderListing = (label) => {
    const { plantSelectList, machineSelectList } = this.props
    const temp = []
    if (label === 'machine') {
      machineSelectList && machineSelectList.map((item) => {
        if (item.Value === '0') return false
        temp.push({ Text: item.Text, Value: item.Value })
        return null
      })
      return temp
    }
    if (label === 'plant') {
      plantSelectList && plantSelectList.map((item) => {
        if (item.Value === '0') return false
        temp.push({ Text: item.Text, Value: item.Value })
        return null
      })
      return temp
    }
  }

  /**
   * @method cancel
   * @description used to Reset form
   */
  cancel = (type) => {
    const { reset } = this.props
    reset()
    // dispatch(reset('AddProcessDrawer'))
    this.toggleDrawer('', '', type)
  }
  cancelHandler = () => {
    // this.setState({ showPopup: true })
    this.cancel('cancel')
  }
  onPopupConfirm = () => {
    this.cancel('cancel')
    this.setState({ showPopup: false })
  }
  closePopUp = () => {
    this.setState({ showPopup: false })
  }
  /**
   * @method onSubmit
   * @description Used to Submit the form
   */
  onSubmit = debounce((values) => {
    const { DataToChange } = this.state
    const { isEditFlag, ID } = this.props

    this.setState({ setDisable: true })
    /** Update existing detail of supplier master **/
    if (isEditFlag) {
      if (DataToChange.ProcessName === values.ProcessName) {
        this.toggleDrawer('', '', 'cancel')
        return false
      }
      let formData = {
        ProcessId: ID,
        ProcessName: values.ProcessName,
        ProcessCode: values.ProcessCode,
        LoggedInUserId: loggedInUserId(),
      }
      this.props.updateProcess(formData, (res) => {
        this.setState({ setDisable: false })
        if (res?.data?.Result) {
          Toaster.success(MESSAGES.UPDATE_PROCESS_SUCCESS)
          this.toggleDrawer('', formData, 'submit')
        }
      })
    } else {
      /** Add new detail for creating supplier master **/

      let formData = {
        ProcessName: values.ProcessName,
        ProcessCode: values.ProcessCode,
        LoggedInUserId: loggedInUserId(),
      }
      this.props.createProcess(formData, (res) => {
        this.setState({ setDisable: false })
        if (res?.data?.Result) {
          Toaster.success(MESSAGES.PROCESS_ADD_SUCCESS)
          this.toggleDrawer('', formData, 'submit')
        }
      })
    }
  }, 500)
  handleKeyDown = function (e) {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
    }
  };
  /**
   * @method render
   * @description Renders the component
   */
  render() {
    const { handleSubmit, isEditFlag, initialConfiguration, t } = this.props
    const { setDisable } = this.state
    return (
      <div>

        <Drawer anchor={this.props.anchor} open={this.props.isOpen}
        // onClose={(e) => this.toggleDrawer(e)}
        >
          {this.state.isLoader && <LoaderCustom />}
          <Container>
            <div className={'drawer-wrapper'}>
              <form noValidate className="form"
                onSubmit={handleSubmit(this.onSubmit.bind(this))}
                onKeyDown={(e) => { this.handleKeyDown(e, this.onSubmit.bind(this)); }}
              >
                <Row className="drawer-heading">
                  <Col>
                    <div className={'header-wrapper left'}>
                      <h3>{isEditFlag ? 'Update Process' : 'Add Process'}

                        <TourWrapper
                          buttonSpecificProp={{ id: "Add_Process_Form" }}
                          stepsSpecificProp={{
                            steps: Steps(t, { isEditFlag: isEditFlag }).ADD_MANAGE_PROCESS
                          }} />
                      </h3>
                    </div>
                    <div
                      onClick={(e) => this.toggleDrawer(e)}
                      className={'close-button right'}
                    ></div>
                  </Col>
                </Row>
                <Row className="ml-0">
                  <Col md="12">
                    <Field
                      id="AddProcessDrawer_ProcessName"
                      label={`Process Name`}
                      name={'ProcessName'}
                      type="text"
                      placeholder={'Enter'}
                      validate={[required, acceptAllExceptSingleSpecialCharacter, maxLength80, checkSpacesInString, checkWhiteSpaces, hashValidation]}
                      component={renderText}
                      onBlur={initialConfiguration?.IsAutoGeneratedProcessCode ? this.checkProcessCode : () => { }}
                      onChange={this.handleProcessName}
                      required={true}
                      className=" "
                      customClassName=" withBorder"
                    // disabled={isEditFlag ? true : false}
                    />
                  </Col>
                  <Col md="12">
                    <Field
                      id="AddProcessDrawer_ProcessCode"
                      label={`Process Code`}
                      name={'ProcessCode'}
                      type="text"
                      placeholder={isEditFlag || initialConfiguration?.IsAutoGeneratedProcessCode ? '-' : 'Enter'}
                      validate={[required, checkSpacesInString, checkWhiteSpaces]}
                      component={renderText}
                      required={true}
                      className=" "
                      customClassName=" withBorder"
                      onChange={initialConfiguration?.IsAutoGeneratedProcessCode ? this.checkProcessCodeUnique : this.handleProcessCode}
                      disabled={isEditFlag || initialConfiguration?.IsAutoGeneratedProcessCode ? true : false}
                    />
                  </Col>
                </Row>

                <Row className="sf-btn-footer no-gutters justify-content-between">
                  <div className="col-sm-12 text-right px-3">
                    <button id="AddProcessDrawer_Cancel"
                      type={'button'}
                      className="mr15 cancel-btn"
                      onClick={this.cancelHandler}
                      disabled={false}
                    >
                      <div className={"cancel-icon"}></div>
                      {'Cancel'}
                    </button>
                    <button
                      id="AddProcessDrawer_Save"
                      type="submit"
                      className="user-btn save-btn"
                      disabled={setDisable}
                    >
                      <div className={"save-icon"}></div>
                      {isEditFlag ? 'Update' : 'Save'}
                    </button>
                  </div>
                </Row>
              </form>
            </div>
          </Container>
        </Drawer>
        {
          this.state.showPopup && <PopupMsgWrapper isOpen={this.state.showPopup} closePopUp={this.closePopUp} confirmPopup={this.onPopupConfirm} message={`${MESSAGES.CANCEL_MASTER_ALERT}`} />
        }
      </div>
    )
  }
}

/**
 * @method mapStateToProps
 * @description return state to component as props
 * @param {*} state
 */
function mapStateToProps(state) {
  const { comman, machine, process, auth } = state
  const { plantSelectList } = comman
  const { machineSelectList } = machine
  const { processUnitData } = process
  const { initialConfiguration } = auth;
  const fieldsObj = selector(state, 'ProcessCode')

  let initialValues = {}

  if (processUnitData && processUnitData !== undefined) {
    initialValues = {
      ProcessName: processUnitData.ProcessName,
      ProcessCode: processUnitData.ProcessCode,
    }
  }
  return { plantSelectList, machineSelectList, processUnitData, initialValues, fieldsObj, initialConfiguration }
}

/**
 * @method connect
 * @description connect with redux
 * @param {function} mapStateToProps
 * @param {function} mapDispatchToProps
 */
export default connect(mapStateToProps, {
  getProcessCode,
  createProcess,
  updateProcess,
  getProcessData,
  getMachineSelectList,
})(
  reduxForm({
    form: 'AddProcessDrawer',
    validate: validateForm,
    enableReinitialize: true,
    touchOnChange: true,
  })(withTranslation(['MachineMaster'])(AddProcessDrawer)),
)
